import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

export const isDev = [
    'localhost',
    '127.0.0.1',
    'xcarol.dev.main.it2go.i2ginfra.cz',
].includes(window.location.hostname);

@Injectable({
    providedIn: 'root',
})
export class DomainDependencyService {

    joditLicense() {
        let license = environment.joditLicense;
        const hostname = window.location.hostname;
        switch (hostname) {
            case 'app.xcarol.cz':
                license = 'A8B6B-0YK80-CDLOK-O988X';
                break;
            case 'xcarol-dev.i2ginfra.cz':
                license = '5A85Y-3JEK3-CDLKJ-UE95X';
                break;
            case 'xcarol-demo.i2ginfra.cz':
                license = 'F005Y-2JJF2-CDOKN-NQAPZ';
                break;
            case 'chcrm-beta.i2ginfra.cz':
                license = '14CBD-1JKH1-CD6JN-R4GCX';
                break;
        }

        return license;
    }

    logo() {
        let logo = '';
        const hostname = window.location.hostname;
        switch (hostname) {
            case 'chcrm-beta.i2ginfra.cz':
                logo = 'charita';
                break;
            default:
                logo = 'XC';
        }

        return logo;
    }
}
